export default "__VITE_ASSET__C2Z959if__"